export default "__VITE_ASSET__1eb14e4b__"